import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styledComponents from "styled-components";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import bgLocale from "date-fns/locale/id";


import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '66vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
  };
  
const Container = styledComponents.div`
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
  `;

const Resi = () => {

    const [page, setPage] = useState({ value: 1 });
    const [pageInfo, setPageInfo] = useState(null);
    const [pageSize, setPageSize] = useState({ value: 24 });

    const [data, setData] = useState([]);
    const [dateValue, setDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);
    const [search, setSearch] = useState(null);

    const handlePage = (event, value) => {
        setPage({ value });
        const serviceToken = window.localStorage.getItem('serviceToken');
        const getData = async () => {
            try {
              const resi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/resi`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                },
                params: {
                    search,
                    dateStart: dateValue,
                    dateEnd: endDateValue,
                    page: value,
                    perPage: pageSize.value
                }
            });
              let number = (value - 1) * (pageSize.value);
              setData(resi.data.result.data.map((v) => {
                number+=1;
                return { ...v, no: number };
              }));
              const pageInfoRes = Object.keys(resi.data.result)
                  .filter((key) => {
                      if (key !== 'data') return true;
                      return false;
                  })
                  .reduce((cur, key) => Object.assign(cur, { [key]: resi.data.result[key] }), {});
              setPageInfo(pageInfoRes);
            } catch (err) {
                console.error(err);
            }
        };
        getData();
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const resi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/resi`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        page: page.value,
                        perPage: pageSize.value
                    }
                });
                let number = 0;
                setData(resi.data.result.data.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                }));
                const pageInfoRes = Object.keys(resi.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: resi.data.result[key] }), {});
                setPageInfo(pageInfoRes);
            } catch (err) {
                console.log(err);
            }
        };
        getData();
    }, [])

    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="h5" fontWeight="700">Resi</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} my={1}>
                <Formik
                    initialValues={{ search: null, date: null }}
                    validate={async (values) => {
                        const errors = {};
                        if (values.search === '') {
                            setSearch(null);
                            try {
                                setPage({ value: 1 });
                                const resi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/resi`, {
                                    headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                    },
                                    params: {
                                        page: 1,
                                        perPage: pageSize.value
                                    }
                                });
                                let number = 0;
                                setData(resi.data.result.data.map((v) => {
                                    number+=1;
                                    return { ...v, no: number };
                                }));
                                const pageInfoRes = Object.keys(resi.data.result)
                                    .filter((key) => {
                                        if (key !== 'data') return true;
                                        return false;
                                    })
                                    .reduce((cur, key) => Object.assign(cur, { [key]: resi.data.result[key] }), {});
                                setPageInfo(pageInfoRes);
                            } catch (err) {
                                console.log(err);
                            }
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        setPage({ value: 1 });
                        values.date = [];
                        if (dateValue !== null && endDateValue !== null) {
                            values.date = [dateValue.toISOString().split('T')[0], endDateValue.toISOString().split('T')[0]];
                        }
                        if (values.date === null && values.search === null) {
                            console.log('Tidak ada parameter untuk diproses');
                        } else {
                            try {
                                const resi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/resi`, {
                                    headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                    },
                                    params: {
                                        search: values.search,
                                        dateStart: values.date.length !== 0 ? values.date[0] : null,
                                        dateEnd: values.date.length !== 0 ? values.date[1] : null,
                                        page: 1,
                                        perPage: pageSize.value
                                    }
                                });
                                let number = 0;
                                setData(resi.data.result.data.map((v) => {
                                    number+=1;
                                    return { ...v, no: number };
                                }));
                                setSearch(values.search);
                                const pageInfoRes = Object.keys(resi.data.result)
                                    .filter((key) => {
                                        if (key !== 'data') return true;
                                        return false;
                                    })
                                    .reduce((cur, key) => Object.assign(cur, { [key]: resi.data.result[key] }), {});
                                setPageInfo(pageInfoRes);
                                setSubmitting(false);
                            } catch (err) {
                                console.log(err);
                            }
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (
                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={bgLocale}>
                                        <Paper
                                            component="div"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                                        >
                                            <MobileDatePicker
                                                label="dari tanggal"
                                                value={dateValue}
                                                onChange={(newValue) => {
                                                    setDateValue(newValue);
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <MobileDatePicker
                                                label="ke tanggal"
                                                value={endDateValue}
                                                onChange={(newValue) => {
                                                    setEndDateValue(newValue);
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Paper>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper
                                        component="div"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                                    >
                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            name="search"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Cari data"
                                            inputProps={{ 'aria-label': 'cari data' }}
                                        />
                                        <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                            <SearchIcon />
                                        </IconButton>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Grid>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '64vh', sm: 740, md: 800} }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 600 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Penerima</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Tanggal</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Ekspedisi</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">No Resi</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Biaya Kirim</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Keterangan</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {data.map((row) => (
                        <TableRow
                            key={row.idlogistik}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell>{row.no}</TableCell>
                            <TableCell>{row.penerima}</TableCell>
                            <TableCell>{row.tgl}</TableCell>
                            <TableCell>{row.ekspedisi}</TableCell>
                            <TableCell>{row.noresi}</TableCell>
                            <TableCell align="right">Rp {row.biayakirim.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                            <TableCell>{row.keterangan}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} my={1}>
                <Stack spacing={0}>
                    <Pagination
                        count={pageInfo ? pageInfo.last_page : 10}
                        color="primary"
                        page={page.value}
                        onChange={handlePage}
                        variant="outlined"
                        shape="rounded"
                    />
                </Stack>
            </Grid>
        </Container>
    )
}

export default Resi
